import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { screen } from 'legacy/styles/screen'

export const RowWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${getToken('space-s')};

  ${screen.md} {
    flex-wrap: nowrap;
  }
`

export const ColumnWrapper = styled.div`
  display: flex;
  flex-basis: 100%;
  flex-direction: column;
  gap: ${getToken('space-xs')};

  ${screen.md} {
    flex-basis: 50%;
  }
`

/** TODO: Refactor DatePicker to have full width from parent **/
export const DatePickerWrapper = styled.div`
  div:nth-child(1),
  input {
    width: 100%;
  }
`
